import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;

export const clearedAutopricerFields: Pick<
	EventInventoryRecord,
	| "Is_AutoPriced"
	| "Is_At_Floor"
	| "Is_At_Ceiling"
	| "Is_Error"
	| "Is_No_Comparables"
	| "Floor_Price"
	| "Ceiling_Price"
	| "Allow_Price_Increase"
	| "AutoPricer_User"
	| "Minutes_Per_Cycle"
	| "MasterRuleId"
	| "MasterOrder"
	| "MasterRuleName"
> = {
	Is_AutoPriced: false,
	Is_At_Floor: false,
	Is_At_Ceiling: false,
	Is_Error: false,
	Is_No_Comparables: false,
	Floor_Price: null,
	Ceiling_Price: null,
	Allow_Price_Increase: null,
	AutoPricer_User: "",
	Minutes_Per_Cycle: null,
	MasterRuleId: null,
	MasterOrder: null,
	MasterRuleName: "",
};

export const { thunk: removeAutopricer, slice: removeAutopricerSlice } = getThunkAndSlice<
	{ listingIds: Array<number> },
	typeof initialState
>({
	initialState,
	path: "api/AutoPricer/RemoveListingRules",
	method: "delete",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const inventoryAllState = rootState.pricing.eventInventoryAll.data;
		const removedListingIds = new Set(params.listingIds);

		const newData = inventoryAllState.map((x) =>
			removedListingIds.has(x.Listing_ID) ? { ...x, ...clearedAutopricerFields } : x,
		);

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		const globalInventoryData = rootState.pricing.globalInventory.data;
		if (globalInventoryData.length) {
			dispatch(
				pricingActions.updateGlobalInventory({
					data: globalInventoryData.map((x) =>
						removedListingIds.has(x.Listing_ID) ? { ...x, ...clearedAutopricerFields } : x,
					),
				}),
			);
		}

		return data;
	},
});
